import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AudioPlayerProvider } from './components/contexts/audio-player';
import axios from "axios";

import './assets/styles/main.css';
import './assets/styles/fonts.css';
import './assets/styles/media.css';

import 'bootstrap-icons/font/bootstrap-icons.css';

import HomePage from './pages/home/page';
import NotFound from './pages/errors/404';
import AdminPage from './pages/admin/page';
import LoginPage from './pages/login/page';
import VideoPage from './pages/video/page';
import PoetsPage from './pages/poets/page';
import PoetryPage from './pages/bestPoets/page';


import Navbar from './components/header/navbar';
import Footer from './components/footer/footer';

const loadCSS = async () => {
  try {
    const response = await axios.post(`/api/record-visit`);
    console.log(response.data)
  } catch (error) {
    console.error('Error:', error);
  }
};

function App() {
  useEffect(() => {
    loadCSS();
  }, []);
  return (
    <AudioPlayerProvider>
    <BrowserRouter>
        <Navbar/>
        <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/video' element={<VideoPage />} />
            <Route path='/poets' element={<PoetsPage />} />
            <Route path='/poetry' element={<PoetryPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path='/admin' element={<AdminPage />} />
            <Route path='*' element={<NotFound />} />
        </Routes>
        <Footer />
    </BrowserRouter>
    </AudioPlayerProvider>
  );
}

export default App;
